import LoginEpics from './login.epic';
import RegisterEpics from './register.epic';
import VerifyEpics from './verify.epic';
import ApplicationsEpics from './application.epic';
import RestoreEpics from './restore.epic';

const AuthEpics = [
  ...LoginEpics,
  ...RegisterEpics,
  ...VerifyEpics,
  ...ApplicationsEpics,
  ...RestoreEpics
];

export default AuthEpics;
